<template>
    <div id="app">
        <div class="message_board">
            <div class="navbar">
                <header>
                    <h1 class="title">
                        An南拥夏栀 - 留言板
                    </h1>
                </header>
            </div>
            <div class="leave-message view home">
                <fieldset class="nya-container">
                    <legend class="nya-title">
                        <!---->
                        <span>留言板</span>
                    </legend>
                    <div class="toolbar mb-15">
                        <div>当前共有 {{ data.length }} 条留言</div>
                        <el-button type="primary" @click="dialog.show = true"
                            >提交留言</el-button
                        >
                    </div>
                    <div style="padding-left: 10px; padding-right: 10px;">
                        <div v-if="!data.length"><h2>暂无留言</h2></div>
                    </div>
                    <div
                        class="mes-items"
                        v-for="(item, index) in data"
                        :key="index"
                        @click="open(item)"
                    >
                        <div class="box">
                            <div class="title">
                                <div class="type">
                                    {{ item.type }}
                                    <i
                                        v-if="item.reply.length > 1"
                                        class="eva eva-checkmark-circle-outline"
                                    ></i>
                                    <i v-else class="eva eva-clock-outline"></i>
                                </div>
                                <div class="date">
                                    {{ formatDate(item.id) }}
                                </div>
                            </div>
                            <div class="content">
                                {{ item.reply[0].content }}
                            </div>
                        </div>
                    </div>
                </fieldset>
                <fieldset class="nya-container">
                    <legend class="nya-title"><span>说明</span></legend>
                    <ul class="nya-list">
                        <li>
                            <b
                                >你的留言都会第一时间推送给作者查看,但不一定会回复</b
                            >
                        </li>
                        <li>
                            <b
                                >请不要留言与网站或者APP无关的内容,否则将全部无视</b
                            >
                        </li>
                        <li>
                            <b
                                >联系方式请填写真实有效的邮箱,否则无法回复你的留言</b
                            >
                        </li>
                        <li>
                            任何无法使用的问题请详细的说明一下,如某个APP无法安装等,否则无视留言
                        </li>
                        <li>
                            如果你的留言包含视频、文件、图片等信息,请通过邮件发送给作者：379417334@qq.com
                        </li>
                    </ul>
                </fieldset>
            </div>

            <el-dialog
                title="查看留言"
                :visible.sync="viewData.show"
                :fullscreen="isMobile"
                top="15vh"
                width="600px"
            >
                <div class="message_board-view-box">
                    <div class="aaaaa" v-if="viewData.id">
                        <b>留言ID：</b><span>{{ viewData.id }}</span>
                    </div>

                    <div class="aaaaa">
                        <b>留言类型：</b><span>{{ viewData.type }}</span>
                    </div>

                    <div class="aaaaa">
                        <b>日期：</b><span>{{ formatDate2(viewData.id) }}</span>
                    </div>
                    <div class="aaaaa">
                        <b>状态：</b
                        ><b>{{
                            viewData.reply.length === 1 ? '待处理' : '已处理'
                        }}</b>
                    </div>

                    <div class="aaaaa" v-if="viewData.reply.length === 1">
                        <b>留言内容：</b>
                        <p v-text="viewData.reply[0].content"></p>
                    </div>

                    <div v-else>
                        <hr />
                        <div class="mb-15">
                            <b>回复记录：</b>
                        </div>
                        <div class="reply-list">
                            <el-timeline>
                                <!-- <el-timeline-item
                                    :timestamp="formatDate2(viewData.id)"
                                    color="#249ffd"
                                >
                                    <b>用户留言：</b>
                                    <div
                                        class="reply-item-content"
                                        v-text="viewData.content.trim()"
                                    ></div>
                                </el-timeline-item> -->
                                <el-timeline-item
                                    v-for="(item, index) in viewData.reply"
                                    :key="index"
                                    :timestamp="formatDate2(item.id)"
                                    :color="
                                        item.type === 'admin'
                                            ? '#fa5477'
                                            : '#249ffd'
                                    "
                                >
                                    <b
                                        >{{
                                            item.type === 'admin'
                                                ? '站长回复'
                                                : '留言回复'
                                        }}：</b
                                    >
                                    <span
                                        style="white-space: pre-line"
                                        v-text="item.content"
                                    ></span>
                                </el-timeline-item>
                            </el-timeline>
                        </div>
                    </div>

                    <!-- <div v-if="viewData.reply">
                        <b>站长回复：</b>
                        <p v-text="viewData.reply"></p>
                    </div> -->

                    <div>
                        <el-divider>回复留言</el-divider>

                        <div v-if="!$route.query.admin">
                            <div class="nya-subtitle mt-15">
                                验证邮箱（与留言时使用的相同）
                            </div>
                            <el-input
                                v-model="viewData.replyMail"
                                class="mb-15"
                                placeholder="请输入留言时使用的邮箱"
                                clearable
                            />
                        </div>

                        <div v-if="isAdmin">
                            <div class="nya-subtitle mt-15">
                                回复内容
                            </div>
                            <el-input
                                v-model="viewData.replyInput"
                                type="textarea"
                                :autosize="{ minRows: 5, maxRows: 8 }"
                                class="mb-15"
                                placeholder="请输入回复内容"
                                clearable
                            />
                        </div>

                        <el-button
                            type="primary"
                            @click="replyFun(viewData.id)"
                        >
                            回复
                        </el-button>
                    </div>
                </div>
            </el-dialog>

            <el-dialog
                title="添加留言"
                :visible.sync="dialog.show"
                :fullscreen="isMobile"
                top="15vh"
                width="600px"
            >
                <div class="message_board-dialog-box">
                    <div class="nya-subtitle mt-15">
                        邮箱
                    </div>
                    <el-input
                        v-model.trim="dialog.mail"
                        type="email"
                        class="mb-15"
                        placeholder="请输入真实有效的邮箱"
                        clearable
                    />

                    <div class="nya-subtitle">
                        类型
                    </div>
                    <el-select
                        v-model="dialog.type"
                        class="full-width mb-15"
                        placeholder="请选择留言类型"
                    >
                        <el-option label="问题反馈" value="问题反馈" />
                        <el-option label="功能建议" value="功能建议" />
                        <el-option label="其他问题" value="其他问题" />
                    </el-select>

                    <div class=" mb-15">
                        <el-checkbox v-model="checked"
                            >我已确认留言内容和网站有关</el-checkbox
                        >
                    </div>

                    <div class="nya-subtitle">
                        内容
                    </div>
                    <el-input
                        v-model="dialog.content"
                        type="textarea"
                        class="mb-15"
                        :autosize="{ minRows: 5, maxRows: 8 }"
                        placeholder="请输入留言信息，如果是问题反馈必须详细说明，否则无视留言。"
                    />

                    <div>
                        <el-button
                            type="primary"
                            :loading="dialog.loading"
                            @click="add"
                        >
                            {{ dialog.loading ? '提交中' : '提交留言' }}
                        </el-button>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/zh-cn';
dayjs.locale('zh-cn');
dayjs.extend(relativeTime);
import axios from './plugins/request';
import validator from 'validator';
export default {
    name: 'Home',
    data() {
        return {
            isMobile: window.innerWidth <= 800,
            dialog: {
                show: false,
                loading: false,
                mail: '',
                content: '',
                type: '问题反馈'
            },
            viewData: {
                show: false,
                id: '',
                mail: '',
                type: '',
                content: '',
                reply: [],
                replyInput: '',
                replyMail: ''
            },
            checked: false,
            data: []
        };
    },
    mounted() {
        this.getData();
    },
    computed: {
        isAdmin() {
            return (
                this.$route.query.admin ||
                this.viewData.replyMail === this.viewData.mail
            );
        }
    },
    methods: {
        replyFun(id) {
            if (!this.isAdmin)
                return this.$notify.error({
                    title: '回复失败',
                    message: '请验证邮箱'
                });
            axios
                .post('/reply', {
                    id: id,
                    reply: this.viewData.replyInput,
                    admin: this.$route.query.admin
                })
                .then(() => {
                    this.$notify.success({
                        title: '回复成功',
                        message: '站长看到后会及时回复'
                    });
                    window.location.reload();
                })
                .catch((err) => {
                    this.$notify.error({
                        title: '回复失败',
                        message: err
                    });
                    console.log(err);
                });
        },
        open(item) {
            this.viewData.id = item.id;
            this.viewData.mail = item.mail;
            this.viewData.type = item.type;
            this.viewData.reply = item.reply;
            this.viewData.show = true;
        },
        add() {
            if (!validator.isEmail(this.dialog.mail)) {
                return this.$notify.error({
                    title: '提交失败',
                    message: '请输入正确的邮箱联系方式'
                });
            }

            if (this.dialog.content <= 15) {
                return this.$notify.error({
                    title: '提交失败',
                    message: '请输入留言信息，且不少于15个字'
                });
            }
            if (!this.checked)
                return this.$notify.error({
                    title: '提交失败',
                    message: '请勾选【我已确认留言内容和网站有关】'
                });
            axios
                .post('/add', {
                    mail: this.dialog.mail,
                    content: this.dialog.content,
                    type: this.dialog.type
                })
                .then((e) => {
                    console.log(e.data);
                    this.$notify.success({
                        title: '提交留言成功',
                        message: '站长看到后会及时回复'
                    });
                    window.location.reload();
                })
                .catch((err) => {
                    this.$notify.error({
                        title: '留言失败',
                        message: err
                    });
                    console.log(err);
                });
        },
        getData() {
            axios
                .get('/list')
                .then((e) => {
                    this.data = e.data.data;
                })
                .catch((err) => {
                    this.$notify.error({
                        title: '获取数据失败',
                        message: err
                    });
                    console.log(err);
                });
        },
        formatDate(date) {
            return dayjs().from(dayjs(date));
        },
        formatDate2(date) {
            return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
        }
    }
};
</script>

<style lang="scss">
#app {
    max-width: 1000px;
    margin: 0 auto;
    padding-left: 10px;
    padding-right: 10px;
}
.toolbar {
    padding-left: 10px;
    padding-right: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.aaaaa {
    margin-bottom: 5px;
}
.el-select-dropdown__item {
    font-size: 1rem !important;
}
.el-dialog__title {
    font-weight: bold;
}
@media (max-width: 500px) {
    .aaaaa {
        margin-bottom: 5px;
        font-size: 1rem !important;
    }
    .mb-15,
    .el-timeline-item__content,
    .el-divider--horizontal,
    .el-button {
        font-size: 1rem !important;
    }
    // input::placeholder {
    //     font-size: 1rem !important;
    // }
    input {
        font-size: 1rem !important;
    }
    .message_board-view-box * {
        font-size: 1rem !important;
    }
}
.nya-list {
    margin-left: 0;
    padding-left: 20px;
    padding-left: 10px;
    li {
        margin: 10px 0;
        line-height: 1.3;
        list-style: none;
        a {
            text-decoration: none;
        }
        &::before {
            position: relative;
            left: -8px;
            content: '';
            display: inline-block;
            border-radius: 50%;
            width: 6px;
            height: 6px;
            background-color: #249ffd;
            border: 3px solid #bde2fe;
        }
        ul.nya-list {
            margin-left: 10px;
            margin-top: 10px;
            li {
                &::before {
                    background-color: #bde2fe;
                    border: 3px solid #249ffd;
                }
            }
        }
    }
}
.mes-items {
    width: calc(100% / 3);
    display: inline-block;
    padding: 10px;
    box-sizing: border-box;
    @media (max-width: 800px) {
        width: 50%;
    }
    @media (max-width: 500px) {
        width: 100%;
    }
    .box {
        border: 1px solid rgb(214, 214, 214);
        cursor: pointer;
        border-radius: 5px;
        .title {
            border-bottom: 1px solid rgb(214, 214, 214);
            padding: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .type {
                font-weight: bold;
                display: flex;
                align-items: center;
                i {
                    margin-left: 3px;
                    font-weight: bold;
                    &.eva-checkmark-circle-outline {
                        color: #47da6b;
                    }
                    &.eva-clock-outline {
                        color: #fa5477;
                    }
                }
            }
            .date {
                color: #c0c4cc;
            }
        }
        .content {
            padding: 10px;
            word-break: break-all;
        }
    }
}
.message_board {
    .reply-item-content {
        display: inline-block;
        white-space: break-spaces;
    }
    .no-msg {
        font-size: 30px;
        text-align: center;
        margin: 40px auto;
    }
    .nya-loading {
        margin: 50px auto;
    }
    .message_board-view-box {
        .nya-subtitle {
            span {
                font-weight: normal;
            }
        }
    }
    &-header {
        padding: 0 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
    }
    .message-card {
        position: relative;
        min-width: 280px;
        display: inline-block;
        width: calc(100% / 3);
        max-width: 100%;
        min-width: 300px;
        padding: 10px;
        box-sizing: border-box;
        cursor: pointer;
        @media (max-width: 500px) {
            width: 100%;
        }
        .message-card-body {
            border: 1px solid var(--border-color);
            border-radius: 5px;
        }
        .header {
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid var(--border-color);
            padding: 10px 15px;
            .type {
                font-weight: bold;
                display: flex;
                align-items: center;
                span {
                    margin-right: 5px;
                }
                i {
                    font-weight: bold;
                    &.eva-checkmark-circle-outline {
                        color: var(--color-success);
                    }
                    &.eva-clock-outline {
                        color: var(--color-danger);
                    }
                }
            }
            .date {
                color: var(--color-text-placeholder);
            }
        }
        .content {
            padding: 10px 15px;
            word-break: break-all;
        }
    }
}
</style>
